import React from 'react';
import { useTranslation } from 'react-i18next';

import { OverviewNumbers } from 'dashboard/types';

import * as Styled from 'dashboard/styles/Overview.style';
import * as Text from 'theme/components/Text.style';

interface NumbersCardProps {
  data: OverviewNumbers | undefined;
  eventsCount: number | undefined;
  isLoading: boolean;
  onEventsClick?: () => void;
}

export default function NumbersCard({
  data,
  eventsCount,
  isLoading,
  onEventsClick,
}: NumbersCardProps): JSX.Element {
  const { t } = useTranslation('pageDashboard');

  const stats = [
    { value: data?.notes_count, label: t('overview.signalsCaptured') },
    {
      value: eventsCount,
      label: t('overview.events'),
      onClick: onEventsClick,
    },
    { value: data?.incidents_count, label: t('overview.incidents') },
  ];

  return (
    <Styled.StatGrid>
      {stats.map((stat) => (
        <Styled.NumbersStatRow
          key={stat.label}
          onClick={stat.onClick}
          style={stat.onClick ? { cursor: 'pointer' } : undefined}
        >
          <Text.H3>{isLoading ? '–' : stat.value ?? 0}</Text.H3>
          <Text.LabelSemibold>{stat.label}</Text.LabelSemibold>
        </Styled.NumbersStatRow>
      ))}
    </Styled.StatGrid>
  );
}
